import React from 'react';

import { EnglishCCA } from 'views/Literaryclub2023/components';

const LifeSkillPage = () => {
  return <EnglishCCA/>;
};

export default LifeSkillPage;